import React from "react";
import { Control, UseFormSetValue, UseFormWatch } from "react-hook-form";

import { Card, Box } from "@mui/material";

import {
  BookingContactBlock,
  SubmitButton,
} from "components/confirm/form/components";
import { CreateQuoteFormState } from "../form/schemaValidation";
import SmsConsentMessage from "components/sms-consent/SmsConsentMessage";
import LuggageCountBlock from "components/confirm/TripDetailsBlock/components/TripItineraryCard/components/AdditionalTripInfoBlock/components/AdditionalTripInfoDialog/components/LuggageCountBlock";

type CreateQuoteFormFieldsProps = {
  control: Control<CreateQuoteFormState>;
  watch: UseFormWatch<CreateQuoteFormState>;
  formId: string;
  isSubmitting: boolean;
  authStage: string;
  setValue: UseFormSetValue<CreateQuoteFormState>;
  getValues: any;
  disableSubmit?: boolean;
  turnstileElement?: React.ReactNode;
};

function CreateQuoteFormFields(props: CreateQuoteFormFieldsProps) {
  const {
    control,
    watch,
    formId,
    isSubmitting,
    setValue,
    getValues,
    disableSubmit,
    turnstileElement,
  } = props;

  return (
    <Card variant="outlined">
      <Box display="flex" flexDirection="column" m={3}>
        {/* Luggage Count */}
        <LuggageCountBlock
          control={control}
          watch={watch}
          setValue={setValue}
          syncStateWithOutboundTrip={true}
        />
        {/* Booking Contact */}
        <Box mb={3}>
          <BookingContactBlock
            control={control}
            watch={watch}
            trackingFrom="quoteRequest"
            setValue={setValue}
            getValues={getValues}
          />
        </Box>
        {/* Submit Button */}
        <SubmitButton
          isCreateQuote
          formId={formId}
          isSubmitting={isSubmitting}
          disabled={disableSubmit}
        />
        {turnstileElement}

        {/* SMS Consent Message */}
        <SmsConsentMessage
          actionButtonName="Send Request"
          typographySx={{ mt: 3 }}
        />
      </Box>
    </Card>
  );
}

export default CreateQuoteFormFields;
